import { Button } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import AccordionTile from '@/components/AccordionTile'
import useDevice from '@/hooks/useDevice'

const EcoTransITVsLuneFaq = () => {
    const { smScreen } = useDevice()

    return (
        <Box>
            <Text
                variant={smScreen ? 'h6' : 'h4'}
                sx={{
                    display: 'inline-block',
                    textAlign: 'center',
                    width: '100%',
                    mb: {
                        xs: 4,
                        sm: 9,
                    },
                }}
            >
                Sounds great, but I have a few questions....
            </Text>
            <AccordionTile
                expanded={true}
                title={`Isn’t it really hard to switch?`}
                description={
                    <>
                        Nope! Because Lune supports EcoTransIT’s format, customer’s can make the
                        switch in just a few seconds.
                        <br />
                        <br />
                        Think of the switch like a F1 pit stop. With a quick tyre change, you’ll be
                        ready to zoom off and win the race in no time.
                    </>
                }
            />
            <AccordionTile
                expanded={true}
                title={`Will I get all the same data?`}
                description={
                    <>
                        Yes, you’ll get all the information you need — and more.
                        <br />
                        <br />
                        Whether it’s filling gaps in your data to achieve next-level granularity, or
                        empowering customers with decision-useful emission reports, your green
                        solutions deliver and delight your customers.
                    </>
                }
            />
            <Box
                sx={{
                    width: '100%',
                    mt: {
                        xs: 4,
                        md: 9,
                    },
                    textAlign: 'center',
                }}
            >
                <Button leftIcon={<ArrowCircleRightIcon />} href={'/request-a-demo'}>
                    Switch in less than 1hr
                </Button>
            </Box>
        </Box>
    )
}

export default EcoTransITVsLuneFaq
